import React from 'react'

const Xformerlytwitter = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
<path d="M20.7989 5.74512H23.8913L17.1354 13.4667L25.0832 23.9739H18.8601L13.986 17.6013L8.40896 23.9739H5.31473L12.5408 15.7149L4.9165 5.74512H11.2975L15.7033 11.5699L20.7989 5.74512ZM19.7136 22.123H21.4271L10.3664 7.49882H8.52768L19.7136 22.123Z" fill="currentColor"></path>
</svg>
    )
}

export default Xformerlytwitter
